import { useQueryGetProgramGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList.query';
import { useQueryGetReport } from 'api/queries/getReport.query';

interface Props {
    reportId: number;
}

export type UseReportPageProvider = ReturnType<typeof useReportPageProvider>;

export const useReportPageProvider = ({ reportId }: Props) => {
    const getReport = useQueryGetReport({ id: reportId });
    const getProgramGeneralHierarchyList = useQueryGetProgramGeneralHierarchyList('Reporting');
    return {
        api: {
            getReport,
            getProgramGeneralHierarchyList,
        },
    };
};
